import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// This hook tracks pageviews in Google Analytics when route changes
export const useGoogleAnalytics = () => {
    const location = useLocation();
    const prevPathRef = useRef<string>(location.pathname);

    useEffect(() => {
        const currentPath = location.pathname;

        // Don't trigger on initial load - as gtag('config') in index.html already does this
        if (prevPathRef.current !== currentPath) {
            // Make sure gtag is defined (it's loaded in index.html)
            if (window.gtag) {
                window.gtag("event", "page_view", {
                    page_path: currentPath,
                    page_title: document.title,
                    page_location: window.location.href,
                });
            }

            prevPathRef.current = currentPath;
        }
    }, [location]);
};

// Add this to the global Window interface
declare global {
    interface Window {
        gtag: (
            command: string,
            action: string,
            params?: Record<string, any>
        ) => void;
        dataLayer: any[];
    }
}
